export const DOC_SOURCE = Object.freeze({
  ADDIN: "ADDIN",
  VT_EDITOR: "VT_EDITOR",
  LOCAL: "LOCAL",
  SAM_GOV: "SAM_GOV",
  SHAREPOINT: "SHAREPOINT",
});
